type ScheduleItem = {
  label: string;
  title: string;
  description: string;
};

type Props = {
  heading?: string;
  items: ScheduleItem[];
};

const gradients = [
  'linear-gradient(145deg, #fff 60%, #f0f4ff 100%)',
  'linear-gradient(145deg, #fff 60%, #f0fff4 100%)',
  'linear-gradient(145deg, #fff 60%, #fff8f0 100%)',
  'linear-gradient(145deg, #fff 60%, #f5f0ff 100%)',
];

const shadows = [
  '0 2px 12px rgba(0, 61, 166, 0.06)',
  '0 2px 12px rgba(22, 163, 74, 0.06)',
  '0 2px 12px rgba(251, 192, 45, 0.08)',
  '0 2px 12px rgba(99, 102, 241, 0.06)',
];

export function ScheduleCards({ heading, items }: Props) {
  return (
    <div style="max-width: 860px; margin: 0 auto; padding: 32px 20px 48px;">
      {heading && (
        <h2 style="font-size: 24px; font-weight: 800; margin-bottom: 24px; letter-spacing: -0.02em; padding-bottom: 0.1em; background: linear-gradient(135deg, var(--m-blue-deep) 0%, var(--m-blue-light) 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;">
          {heading}
        </h2>
      )}
      <div style="display: flex; flex-direction: column; gap: 16px;">
        {items.map((item, i) => (
          <div
            key={i}
            style={`display: flex; gap: 20px; align-items: flex-start; padding: 24px; background: ${gradients[i % gradients.length]}; border: 1px solid #e2e8f0; border-radius: 12px; box-shadow: ${shadows[i % shadows.length]}; transition: box-shadow 0.2s ease, transform 0.2s ease;`}
          >
            <div style="width: 36px; height: 36px; border-radius: 50%; border: 2px solid var(--m-blue); background: transparent; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
              <span style="color: var(--m-blue); font-size: 15px; font-weight: 700;">{i + 1}</span>
            </div>
            <div style="flex: 1; min-width: 0;">
              <p style="font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 1.5px; color: var(--m-blue); margin: 0 0 4px;">
                {item.label}
              </p>
              <p style="font-size: 17px; font-weight: 700; color: #1a1a1a; margin: 0 0 6px;">
                {item.title}
              </p>
              <p style="font-size: 15.5px; line-height: 1.7; color: #616161; margin: 0;">
                {item.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
